import React, { Component } from "react";
import $ from "jquery";
import { getStateDetailsNew, dataUpdate, enquiryForm } from '../service'
import ReCAPTCHA from "react-google-recaptcha";
import DeviceDetector from "device-detector-js";
import axios from 'axios'
import moment from 'moment';
const deviceDetector = new DeviceDetector();
const userAgent = "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_13_6) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/69.0.3497.81 Safari/537.36";
const device = deviceDetector.parse(userAgent);
let flag = false;
var cityName = window.location.host.split('.')[0]
// var cityName ="delhi"
class FormData extends Component {
  constructor(props) {
    super(props)
    this.state = {
      courseList: [],
      siteList: [],
      psource: "",
      ssource: "",
      ip: "",
      cityselectedPhoneNumber: "",
      CourseOfCity: [],
      captchaValue: "1",
    }
    this.onChangeCaptcha = this.onChangeCaptcha.bind(this)
    this.onExpiredCaptcha = this.onExpiredCaptcha.bind(this)
  }
  componentDidMount() {
    $(function () {
      function rescaleCaptcha() {
        var width = $('.g-recaptcha').parent().width();
        var scale;
        if (width < 302) {
          scale = width / 302;
        } else {
          scale = 1.0;
        }
        $('.g-recaptcha').css('transform', 'scale(' + scale + ')');
        $('.g-recaptcha').css('-webkit-transform', 'scale(' + scale + ')');
        $('.g-recaptcha').css('transform-origin', '0 0');
        $('.g-recaptcha').css('-webkit-transform-origin', '0 0');
      }
      rescaleCaptcha();
      $(window).resize(function () { rescaleCaptcha(); });
    });
    $("#submitbutton").attr('disabled', true);
    localStorage.removeItem('EnqNo')
    const queryParams = new URLSearchParams(window.location.search)
    const psource = queryParams.get("psource")
    const ssource = queryParams.get("ssource")
    this.setState({
      psource: psource,
      ssource: ssource
    });
    $("#pleaseWait").hide();
    getStateDetailsNew().then((data) => {
      this.setState({
        listState: data.result.stateData
      });
    });
    this.getData()
    const postData = {
      "cityName": cityName,
      "functionName": "courseListWithCity"
    }
    dataUpdate(postData).then((data) => {
      if (data.data.result.courses.length > 0) {
        this.setState({
          courseList: data.data.result.courses,
        });
      }
    });
  }
  getData = async () => {
    const res = await axios.get('https://geolocation-db.com/json/')
    this.setState({
      ip: res.data.IPv4
    });
  }
  formSubmit(e) {
    $("#submitbutton").hide()
    $("#pleaseWait").show();
    e.preventDefault();
    localStorage.setItem('Name', $("#txtCounsellingName").val())
    localStorage.setItem('PhoneNumber', $("#txtCounsellingMobile").val())
    localStorage.setItem('leadEmail', $("#txtCounsellingEmail").val())
    localStorage.setItem('leadCourse', $("#cmbCounsellingCourse").find(":selected").text())
    let psource = this.state.psource
    let ssource = this.state.ssource
    let centre = $("#councellingCentre").val();
    let name = $("#txtCounsellingName").val();
    let email = $("#txtCounsellingEmail").val();
    let mobileNo = $("#txtCounsellingMobile").val();
    let qualification = $("#councellingHighestQualification").val()
    let courseId = $("#cmbCounsellingCourse").val();
    let courseName = $("#cmbCounsellingCourse").find(":selected").text()
    let siteId = centre;
    let stateId = $("#councellingState").val();
    let cityId = $("#councellingCity").val();
    let currentUrl = window.location.href;
    let ipAdd = "";
    let saveId = "";
    var contactPost = {
      name: name,
      emailId: email,
      mobileNumber: mobileNo,
      courseId: courseId,
      stateId: "0",
      cityId: "0",
      centerId: siteId,
      reason: "",
      isCampaign: true,
      ipAddress: this.state.ip,
      sSource: (ssource !== null && ssource !== "null" && ssource !== "") ? ssource : this.props.fromPage,
      pSource: (psource !== null && psource !== "null" && psource !== "") ? psource : (device.device.type == "desktop" ? "Website" : "Mobile Website"),
      pageUrl: currentUrl,
      browser: device.client.name,
      devices: device.device.type,
      submission_date: Date.parse(moment(new Date()).format('YYYY/MM/DD hh:mm A')),
      functionName: "saveContactUs",
      courseName: courseName,
      sub_domain:cityName
    }
    dataUpdate(contactPost).then((data) => {
      console.log("dataaaaaa", data)
      saveId = data.data.result.id
      this.formSubmitFunction(name, email, mobileNo, stateId, siteId, courseId, ipAdd, currentUrl, qualification, cityId, saveId)
    });
  }
  formSubmitFunction(name, email, mobileNo, stateId, siteId, courseId, ipAdd, currentUrl, qualification, cityId, saveId) {
    let psource = this.state.psource
    let ssource = this.state.ssource
    var postData = {
      // "I_Brand_ID": brandId,
      "I_Brand_ID": "111",
      "S_First_Name": name,
      "S_Last_Name": null,
      "S_Email_ID": email,
      "S_Mobile_No": mobileNo,
      "S_Phone_No": null,
      "I_Pref_State_ID": "0",
      "I_Pref_Center_ID": siteId,
      "I_CourseEnquiryMaster_ID": courseId,
      "S_Comments": null,
      "S_CurrentlyDoing": "",
      // "S_Brand_Code": brandCode,
      "S_Brand_Code": "LAPA",
      "S_Ip_Address_Location": this.state.ip,
      // "S_Ip_Address_Location": "3.6.11.84",
      "S_Form_Name": null,
      "S_S_Source": (ssource !== null && ssource !== "null" && ssource !== "") ? ssource : this.props.fromPage,
      "S_P_Source": (psource !== null && psource !== "null" && psource !== "") ? psource : (device.device.type == "desktop" ? "Website" : "Mobile Website"),
      "S_Network": null,
      "S_Creative": null,
      "S_Keyword": null,
      "S_Placement": null,
      "S_Adposition": null,
      "S_MatchType": null,
      "S_accid": null,
      "S_Page_URL": currentUrl,
      // "S_Page_URL": "http://3.6.11.84/",
      "S_Pages_Visited": "",
      "I_City_ID": "0"
    }
    enquiryForm(postData).then((data) => {
      try {
        localStorage.setItem("userMobileNo", mobileNo)
        var parseResult = JSON.parse(data.data.body)
        var enqNo = parseResult.EnqNo
        if (parseResult.result == "Success") {
          enqNo = ((enqNo === "" || enqNo === "null" || enqNo === null) ? 'NA' : enqNo)
          localStorage.setItem('EnqNo', enqNo);
          var postData = {
            "functionName": "saveEnquireNumber",
            "id": saveId,
            "enquireNumber": enqNo
          }
          console.log("mmmmmmmmmmmmmmm", postData)
          dataUpdate(postData).then((data) => {
          });
          window.location.href = '/thankyou'
        }
      } catch (err) {
        console.log('error.......', err);
        localStorage.setItem('EnqNo', 'NA');
        window.location.href = '/thankyou'
      }
    })
  }
  nameValidate() {
    let name = $("#txtCounsellingName").val();
    var charactersName = /^[a-zA-Z\s]*$/;
    if (!name || charactersName.test(name) === false) {
      $("#txtCounsellingName").focus()
      $("#txtCounsellingNameError").show();
    }
    else {
      $("#txtCounsellingNameError").hide();
    }
    this.handleonChange()
  }
  mobileValidate() {
    let name = $("#txtCounsellingMobile").val();
    var charactersName = /^[5-9][0-9]{9}$/;
    if (!name || charactersName.test(name) === false) {
      $("#txtCounsellingMobile").focus()
      $("#txtCounsellingMobileError").show();
    }
    else {
      $("#txtCounsellingMobileError").hide();
    }
    this.handleonChange()
  }
  emailValidate() {
    let name = $("#txtCounsellingEmail").val();
    var charactersEmail = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
    if (!name || charactersEmail.test(name) === false) {
      $("#txtCounsellingEmail").focus()
      $("#txtCounsellingEmailError").show();
    }
    else {
      $("#txtCounsellingEmailError").hide();
    }
    this.handleonChange()
  }
  handleonChangeCourse(e) {
    var value = e.target.value;
    if (value === "0") {
      $("#SelectCourse").show();
      this.setState({
        CourseOfCity: [],
      });
    }
    else {
      $("#SelectCourse").hide();
      const postData = {
        "functionName": "campaignCentres",
        "cityName": cityName,
        "courseId": $("#cmbCounsellingCourse").val()
      }
      dataUpdate(postData).then((data) => {
        if (data.data.result.centres.length > 0) {
          this.setState({
            CourseOfCity: data.data.result.centres,
          });
        }
      })
    }
    this.handleonChange()
  }
  handleonChangeCentre(e) {
    var valuesss = e.target.value;
    if (valuesss == "0" || valuesss === "null" || valuesss === null) {
      $("#SelectCityError").show();
    }
    else {
      let obj = this.state.CourseOfCity.find(obj => obj.centreId.toString() === valuesss);
      localStorage.setItem('callMeBackNumber', obj.callMeBackNumber)
      localStorage.setItem('callNowNumber', obj.callNowNumber)
      localStorage.setItem('PhoneNumberCenter', obj.mobileNumber)
      localStorage.setItem('CenterChoosed', obj.centreName)
      localStorage.setItem('EmailIdCenter', obj.centerEmailId)
      $("#SelectCityError").hide();
    }
    this.handleonChange()
  }
  onChangeCaptcha(value) {
    console.log("onChangeCaptcha: ", value);
    this.setState({
      captchaValue: '1'
    }, () => {
      this.handleonChange()
    })
  }
  onExpiredCaptcha(value) {
    console.log("onExpiredCaptcha: ", value);
    this.setState({
      captchaValue: ""
    }, () => {
      this.handleonChange()
    })
  }
  handleonChange() {
    $("#reCaptchaerror").hide();
    $("#submitbutton").attr('disabled', true);
    let flag = true
    let centre = $("#councellingCentre").val();
    let name = $("#txtCounsellingName").val();
    let email = $("#txtCounsellingEmail").val();
    let mobileNo = $("#txtCounsellingMobile").val();
    let courseId = $("#cmbCounsellingCourse").val();
    var charactersName = /^[a-zA-Z\s]*$/;
    var mobile = /^\d{10}$/;
    var characters = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
    if (!$("#txtCounsellingName").val() || charactersName.test(name) === false) {
      flag = false
    }
    if (!mobileNo || mobile.test(mobileNo) === false) {
      flag = false
    }
    if (mobileNo.length != 10 && (!$("#txtCounsellingMobile").val().match(/^[0-9]{10}$/))) {
      flag = false
    }
    if (!email) {
      flag = false
    }
    if (characters.test(email) == false) {
      flag = false
    }
    if (courseId == "0") {
      flag = false
    }
    if (centre == "0" || centre == "null" || centre == null) {
      flag = false
    }
    if ((this.state.captchaValue === "") && (flag === true)) {
      $("#reCaptchaerror").show();
      flag = false
    }
    if (flag === true) {
      $("#submitbutton").attr('disabled', false);
    }
  }
  render() {
    return (
      <div className="formWrapper">
        <div className="col-xs-12 formSection">
          {" "}
          <a name="topformlink"></a>
          <div className="studenEnquiry" data-aos="fade-up">
            <h2 className="text-center enquiryText">
              ENQUIRY FORM <div className="fromSpan">for Free Career Counselling</div>
            </h2>
            <form id="formCareer">
              <div className="form-group">
                <input
                  onKeyUp={() => this.nameValidate()} onChange={() => this.handleonChange()}
                  id="txtCounsellingName"
                  placeholder="Enter Your Name*"
                  className="form-controls"
                />
                <div id='PleaseEnterYourNameError' className="error">
                  Please enter your name
                </div>
                <div id='txtCounsellingNameError' className="error">
                  Please enter a valid name (A-Z, a-z)
                </div>
              </div>
              <div className="form-group">
                <input
                  id="txtCounsellingMobile"
                  placeholder="Mobile No *"
                  autoComplete="off" onKeyUp={() => this.mobileValidate()} onChange={() => this.handleonChange()} maxlength="10"
                  className="form-controls"
                />
                <div class="error" id='enterYourMobileNumberError'>Please enter your mobile number</div>
                <div class="error" id='txtCounsellingMobileError'>Please enter a valid mobile number</div>
              </div>
              <div className="form-group">
                <input
                  id='txtCounsellingEmail' autoComplete="off" onKeyUp={() => this.emailValidate()} onChange={() => this.handleonChange()}
                  placeholder="Enter Email Id*"
                  className="form-controls"
                />
                <div class="error" id="enterYourEmailError">Please enter your email Id</div>
                <div class="error" id='txtCounsellingEmailError'>Please enter a valid email Id</div>
              </div>
              <div className="form-group">
                <select name="ddl_courses" id="cmbCounsellingCourse" onChange={(e) => this.handleonChangeCourse(e)} className="form-controls">
                  <option value={0}>Select Course interested in *</option>
                  {this.state.courseList.map((course, k) => (
                    <option key={k} value={course.courseId}>{course.courseName}</option>
                  ))}
                </select>
                <div id='SelectCourse' className="error">
                  Select Course interested in
                </div>{" "}
              </div>
              <div className="form-group">
                <select name="ddlCenter" id="councellingCentre" onChange={(e) => this.handleonChangeCentre(e)} className="form-controls">
                  <option value="0">Select Centres</option>
                  {this.state.CourseOfCity.map((listCity, t) => (
                    <option value={listCity.centreId} key={t} >{listCity.centreName}</option>
                  ))}
                </select>
                <div id='SelectCityError' className="error">
                  Select Center
                </div>
              </div>
              <div className="afterverification">
                <div className="captcha-divv g-recaptcha">
                  <ReCAPTCHA
                    sitekey={process.env.REACT_APP_RECAPTCHA_KEY}
                    onChange={(e) => this.onChangeCaptcha(e)}
                    onExpired={(e) => this.onExpiredCaptcha(e)}
                  />
                  <div class="error" id='reCaptchaerror'>Please select Recaptcha checkbox.</div>
                </div>
                <p className="text-blacks">
                  <small>
                    <em>
                      By clicking on Submit, I allow Lakmé Academy Powered by
                      Aptech to contact me, and use &amp; share my personal data
                      as per the{" "}
                      <a
                        href="https://www.lakme-academy.com/privacy-policy"
                        title="Privacy Policy"
                        target="_blank"
                      >
                        Privacy Policy.
                      </a>
                    </em>
                  </small>
                </p>
                <div className="btn-interest">
                  <button
                    id="submitbutton" onClick={(e) => this.formSubmit(e)}
                    className="bur btn submit button dark"
                  >
                    I'm interested
                  </button>
                  <button id='pleaseWait'
                    className="bur btn submit button dark"
                    disabled
                  >
                    PLEASE WAIT....
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}
export default FormData;
